import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull,
    OnSubmitValidator
} from '../../containers/DefaultStyles/FormDetails';

import { validateStep4 as validate } from './validations';
import submissionErrorHandler from '../../utils/submissionErrorHandler';
import { isPortrait } from '../../utils/size';

const InfoText = styled.span`
    font-size: 12px;
    margin: 0 8px;
    ${() => isPortrait() && `margin-top: 0.5em`};
`;

class VoteRegistrationStep4Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on">
                <MultipleGroupFull style={{ flexDirection: `column` }}>
                    <InfoText>{this.props.infoTextIdNumber}</InfoText>
                    <Field
                        name="idNumber"
                        onBlur={() => this.checkForBlurError('idNumber')}
                        submissionError={this.state.errors.includes('idNumber')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        placeholder="ID Number"
                        label="ID Number"
                        autocomplete="off"
                        maxLength={this.props.maxLengthIdNumber}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="firstRegistration"
                        component={CheckboxGroup}
                        label="First registration"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="hasMailingAddress"
                        component={CheckboxGroup}
                        label="I get my mail at a different mailing address"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="changeOfName"
                        component={CheckboxGroup}
                        label="I have changed my name"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="changeOfAddress"
                        component={CheckboxGroup}
                        label="I have changed my address"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        {this.props.isOnlineRegistrationAvailable && (
                            <Button label="Back" onClick={this.props.onBack} />
                        )}
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );
                                if (errors.length === 0 && !this.props.invalid) {
                                    this.props.handleSubmit();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                type="submit"
                                label="Continue"
                                disabled={this.props.invalid}
                            />
                        </OnSubmitValidator>
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep4Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    currentFormValues: PropTypes.object,
    infoTextIdNumber: PropTypes.string,
    maxLengthIdNumber: PropTypes.number,
    minLengthIdNumber: PropTypes.number,
    isOnlineRegistrationAvailable: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {},
        currentFormValues: (state.form['voteRegistrationStep4Form'] || {}).values
    })),
    reduxForm({
        form: 'voteRegistrationStep4Form',
        destroyOnUnmount: false,
        validate
    })
)(VoteRegistrationStep4Form);
